import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'

// UI
import { withStyles } from '@material-ui/core/styles'
import Collapse from '@material-ui/core/Collapse'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'

// Icons
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import BuildIcon from '@material-ui/icons/Build'
import CodeIcon from '@material-ui/icons/Code'
import ExploreIcon from '@material-ui/icons/Explore'
import HomeIcon from '@material-ui/icons/Home'
import InsertChartIcon from '@material-ui/icons/InsertChart'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'
import ListIcon from '@material-ui/icons/List'
import SearchIcon from '@material-ui/icons/Search'

const drawerWidth = 240

const styles = theme => ({
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 5,
  },
  toolbar: theme.mixins.toolbar,
})

class SideMenu extends React.Component {

  state = { buildMenu: true, accountMenu: false, developerMenu: false }

  handleClickBuildMenu = () => {
    this.setState(state => ({ buildMenu: !state.buildMenu }))
  }

  // TODO: Merge with above
  handleClickAccountMenu = () => {
    this.setState(state => ({ accountMenu: !state.accountMenu }))
  }

  handleClickDeveloperMenu = () => {
    this.setState(state => ({ developerMenu: !state.developerMenu }))
  }

  render() {
    const { classes } = this.props

    return (
      <Drawer
        variant='permanent'
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.toolbar} />
        <List component='nav'>
          <ListItem component={Link} to='/' button>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText inset primary='Home' />
          </ListItem>
          <ListItem button onClick={this.handleClickBuildMenu}>
            <ListItemIcon>
              <BuildIcon />
            </ListItemIcon>
            <ListItemText inset primary='Tools' />
            {this.state.buildMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.buildMenu} timeout='auto' unmountOnExit>
            <List component='div' disablePadding>
              <ListItem component={Link} to='/search' button className={classes.nested}>
                <ListItemIcon>
                  <SearchIcon />
                </ListItemIcon>
                <ListItemText inset primary='Search' />
              </ListItem>
              <ListItem component={Link} to='/parse' button className={classes.nested}>
                <ListItemIcon>
                  <ListIcon />
                </ListItemIcon>
                <ListItemText inset primary='Parse' />
              </ListItem>
            </List>
          </Collapse>
          <ListItem button onClick={this.handleClickAccountMenu}>
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText inset primary='Account' />
            {this.state.accountMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.accountMenu} timeout='auto' unmountOnExit>
            <List component='div' disablePadding>
              <ListItem component={Link} to='/usage' button className={classes.nested}>
                <ListItemIcon>
                  <InsertChartIcon />
                </ListItemIcon>
                <ListItemText inset primary='Usage' />
              </ListItem>
            </List>
          </Collapse>
          <ListItem button onClick={this.handleClickDeveloperMenu}>
            <ListItemIcon>
              <CodeIcon />
            </ListItemIcon>
            <ListItemText inset primary='Developer' />
            {this.state.developerMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.developerMenu} timeout='auto' unmountOnExit>
            <List component='div' disablePadding>
              <ListItem component={Link} to='/explore' button className={classes.nested}>
                <ListItemIcon>
                  <ExploreIcon />
                </ListItemIcon>
                <ListItemText inset primary='API Explorer' />
              </ListItem>
              <ListItem component='a' href='https://docs.addresscloud.com' target='_docs' button className={classes.nested}>
                <ListItemIcon>
                  <LibraryBooksIcon />
                </ListItemIcon>
                <ListItemText inset primary='Documentation' />
              </ListItem>
            </List>
          </Collapse>
        </List>
      </Drawer>
    )
  }
}

SideMenu.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(SideMenu)
